import BasePostGridSlider from "@PegasusCore/pegasus-one-post-grid-slider/src/script";
import wheel from "wheel";
import normalizeWheel from "normalize-wheel";

class PostGridSlider extends BasePostGridSlider {
    isAnimating = false;

    init() {
        super.init();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    window.dispatchEvent(new Event('resize'));
                    observer.disconnect(); // Only trigger once
                }
            });
        }, { threshold: 0.1 });

        //for flickity
        observer.observe(this.sliderContainer);

        this.slider.on("settle", () => {
            this.selectedSlideId = this.slider.selectedElement.id;
            setTimeout(() => {
                this.isAnimating = false;
            }, 500);
        });

        wheel.addWheelListener(
            this.sliderContainer,
            (event) => {
                const wheelNormalized = normalizeWheel(event);

                // Define thresholds
                const horizontalScrollThreshold = 0.8;

                // Calculate horizontal ratio
                const horizontalRatio =
                    Math.abs(wheelNormalized.pixelX) /
                    (Math.abs(wheelNormalized.pixelX) +
                        Math.abs(wheelNormalized.pixelY));

                // Explicitly handle vertical scrolling
                if (horizontalRatio < horizontalScrollThreshold) {
                    event.stopPropagation();
                    if (this.getSafariVersion() !== null) {
                        window.scroll(
                            window.scrollX,
                            window.scrollY + wheelNormalized.pixelY
                        );
                    }
                    return;
                }

                // Prevent default browser behaviour for horizontal scrolling
                event.preventDefault();

                this.slider.on("select", () => {
                    this.isAnimating = true;
                });

                if (this.isAnimating) {
                    return;
                }

                // Handle horizontal scrolling logic
                if (
                    Math.abs(this.slider.x) + wheelNormalized.pixelX + 20 >
                        this.slider.slideableWidth ||
                    Math.abs(this.slider.x) + wheelNormalized.pixelX < 0
                ) {
                    return;
                }

                if (wheelNormalized.pixelX > 0) {
                    this.slider.next();
                } else {
                    this.slider.previous();
                }
            },
            { passive: false }
        );

        this.$nextTick(() => {
            //resize to trigger resize/reinit of flickity
            window.dispatchEvent(new Event("resize"));
        });

        
    }

    getSafariVersion() {
        const userAgent = navigator.userAgent;

        // Check if the user agent is Safari (but not Chrome, which also contains "Safari" in its user agent)
        const safariMatch = userAgent.match(/Version\/(\d+\.\d+).*Safari/);

        if (safariMatch) {
            return safariMatch[1]; // The first capture group is the version number
        } else {
            return null; // Not Safari
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGridSlider", () => new PostGridSlider());
});
